import React from "react";
import { m as motion } from "../../shared/components/Motion";
import "./certificates-skeleton.css";

const CertificatesSkeleton = () => {
  const skeletonVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0.5 },
    visible: { opacity: 1 },
  };

  // Show 9 skeleton cards by default (matches typical grid layout)
  const skeletonCount = 9;

  return (
    <motion.section
      className="certificates section"
      id="certificates"
      initial="hidden"
      animate="visible"
      variants={skeletonVariants}
    >
      {/* Title and Subtitle */}
      <motion.h2
        className="section__title skeleton-title-large"
        variants={itemVariants}
      />
      <motion.span
        className="section__subtitle skeleton-subtitle"
        variants={itemVariants}
      />

      {/* Certificates Container */}
      <motion.div className="certificates__container container grid">
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <motion.div
            key={index}
            className="skeleton-certificates-content"
            variants={itemVariants}
          >
            {/* Certificate Image Skeleton */}
            <motion.div
              variants={itemVariants}
              className="skeleton-certificate-image"
            />
            {/* View More Button Skeleton */}
            <motion.div
              variants={itemVariants}
              className="skeleton-certificate-button"
            />
          </motion.div>
        ))}
      </motion.div>
    </motion.section>
  );
};

export default CertificatesSkeleton;
